// extracted by mini-css-extract-plugin
module.exports = {"asterisk":"Asterisk_asterisk__2hLCn"};